<!--
  CreateInternalDashboard.vue — REPLACES the current scaffold (Create & Manage).
  Drop into web/src/views/CreateInternalDashboard.vue
  NOT compile-verified (no Vue build) — Manish to test/refine locally.
  Grid of dashboards + create/edit form (name, description, HTML, data-set picker,
  assign roles [allow] and users [allow/deny]). Grants posted as
  [{grantee_type:'role'|'user', grantee_id, access:'allow'|'deny'}].

  ⚠ CONFIRM ENDPOINTS for the roles + Elomark-users dropdowns (marked below) —
  these aren't part of this feature; wire them to your existing list endpoints.
  Grid is a vs-table for reliability — swap to the project AG grid if preferred.
-->



<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Manage Internal Dashboard</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>

      <!-- Dashboard data source: all or nothing, emp-dash or Supabase.
           Shown only to holders of the 'dashboard-data-source' permission;
           the server checks the same permission on every change. -->
      <div v-if="canSwitchSource" class="mt-4 mb-6 p-4" style="border:1px solid #ddd;border-radius:6px">
        <h4 class="mb-2">Dashboard data source</h4>
        <p v-if="source" class="mb-3">
          Every dashboard reads its figures from <strong>{{ sourceLabel(source) }}</strong>.
        </p>
        <p v-else class="mb-3">The current setting could not be read.</p>
        <vs-button v-if="source" color="danger" type="border" :disabled="switching" @click="confirmSwitch">
          Switch every dashboard to {{ sourceLabel(otherSource) }}
        </vs-button>
        <ul v-if="sourceChanges.length" class="text-sm mt-3">
          <li v-for="c in sourceChanges" :key="c.id">
            {{ formatUtc(c.changed_at) }} — {{ c.changed_by_name || "unknown user" }}:
            {{ sourceLabel(c.from_source) }} → {{ sourceLabel(c.to_source) }}
          </li>
        </ul>
      </div>

     <ClientDataGrid :key="internalDashboardComponentKey" ref="InternalDashboardDataGrid"
          :columnDefs="internalDashboardColumnDef" :rowData="dashboards">
        </ClientDataGrid>


    </vx-card>
  
  </div>
</template>



<script>
import axios from "@/axios.js";
import defineAbilitiesFor from "@/config/abilities";
import ClientDataGrid from "@/components/aggrid/AggridClient.vue";

export default {
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
      self.canSwitchSource = data.can("update", "dashboard-data-source");
      if (self.canSwitchSource) self.loadSource();
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
  },
  components: {
    ClientDataGrid
  },
  data() {
    return {
      internalDashboardColumnDef: [
        {
          headerName: "Actions",
          field: "transactions",
          cellRenderer: "CellRendererActions",
          suppressHeaderMenuButton: true,
          pinned: true,
          width: 90
        },
        {
          headerName: "Name",
          field: "name",
          flex: 1,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Description",
          field: "description",
          flex: 1,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },


      ],
      internalDashboardComponentKey: 0,
      dashboards: [],
      dataSets: [],
      roles: [],
      users: [],
      editing: false,
      form: { id: null, name: "", description: "", dashboard: "", data_set_id: null, roleIds: [] },
      userAccess: {}, // { userUuid: 'allow'|'deny' }
      canSwitchSource: false,
      source: null,
      sourceChanges: [],
      switching: false
    };
  },
  computed: {
    otherSource() {
      return this.source === "emp-dash" ? "supabase" : "emp-dash";
    }
  },
  methods: {
     goBack: function() {
      this.$router.push("/dashboard")
    },
    getInternalDashboardDataSource() {
      axios.get(this.api("all_internal_dashboards")).then(r => { this.dashboards = r.data || []; });
    },
    api(path) { return this.$base_url + "/api/internal_dashboard/" + path; },
    sourceLabel(s) {
      return s === "emp-dash" ? "emp-dash" : s === "supabase" ? "Supabase" : "(not set)";
    },
    formatUtc(iso) {
      if (!iso) return "";
      const t = new Date(iso);
      if (isNaN(t.getTime())) return iso;
      return t.toISOString().slice(0, 16).replace("T", " ") + " UTC";
    },
    loadSource() {
      axios.get(this.api("dashboard_source")).then(r => {
        this.source = r.data.source;
        this.sourceChanges = r.data.changes || [];
      }).catch(() => { this.source = null; });
    },
    confirmSwitch() {
      const to = this.otherSource;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Switch dashboard data source",
        text: "Switch every dashboard to " + this.sourceLabel(to) + "? Everyone will see "
          + this.sourceLabel(to) + " figures from their next page load.",
        acceptText: "Switch",
        accept: () => this.switchSource(to)
      });
    },
    switchSource(to) {
      this.switching = true;
      axios.post(this.api("dashboard_source"), { source: to }).then(r => {
        this.$vs.notify({ title: "Switched", text: "Dashboards now read from " + this.sourceLabel(r.data.source) + ".", color: "success" });
        this.loadSource();
      }).catch(() => {
        this.$vs.notify({ title: "Not switched", text: "The data source was not changed.", color: "danger" });
      }).finally(() => { this.switching = false; });
    },
    // loadList() {
    //   axios.get(this.api("all_internal_dashboards")).then(r => { this.dashboards = r.data || []; });
    // },
    // loadRefs() {
    //   axios.get(this.api("list_internal_dashboard_data_sets")).then(r => { this.dataSets = r.data || []; this.paginate_total = Math.ceil(this.dataSets.length / this.paginate); }).catch(() => { });
    //   // ⚠ CONFIRM: roles list endpoint
    //   axios.get(this.$base_url + "/api/roles/all_roles").then(r => { this.roles = r.data && r.data.data ? r.data.data : (r.data || []); }).catch(() => { });
    //   // ⚠ CONFIRM: Elomark users list endpoint (is_client='n')
    //   axios.get(this.$base_url + "/api/elomark_users/fetch_all_elomark_users").then(r => { this.users = r.data || []; }).catch(() => { });
    // },
    // newDashboard() {
    //   this.form = { id: null, name: "", description: "", dashboard: "", data_set_id: null, roleIds: [] };
    //   this.userAccess = {};
    //   this.editing = true;
    // },
    // edit(d) {
    //   this.form = { id: d.id, name: d.name, description: d.description, dashboard: "", data_set_id: d.data_set_id, roleIds: [] };
    //   this.userAccess = {};
    //   // load HTML + grants
    //   axios.get(this.api("serve_internal_dashboard/" + d.id)).then(r => { this.form.dashboard = r.data; }).catch(() => { });
    //   axios.post(this.api("get_internal_dashboard_grants"), { item: { id: d.id } }).then(r => {
    //     (r.data || []).forEach(g => {
    //       if (g.grantee_type === "role") this.form.roleIds.push(g.grantee_id);
    //       else if (g.grantee_type === "user") this.$set(this.userAccess, g.grantee_id, g.access);
    //     });
    //   }).catch(() => { });
    //   this.editing = true;
    // },
    // setUser(uuid, val) {
    //   if (val === "none") this.$delete(this.userAccess, uuid);
    //   else this.$set(this.userAccess, uuid, val);
    // },
    // buildGrants() {
    //   const grants = [];
    //   (this.form.roleIds || []).forEach(rid => grants.push({ grantee_type: "role", grantee_id: rid, access: "allow" }));
    //   Object.keys(this.userAccess).forEach(uid => grants.push({ grantee_type: "user", grantee_id: uid, access: this.userAccess[uid] }));
    //   return grants;
    // },
    // save() {
    //   const item = {
    //     name: this.form.name,
    //     description: this.form.description,
    //     dashboard: this.form.dashboard,
    //     data_set_id: this.form.data_set_id,
    //     grants: this.buildGrants()
    //   };
    //   const path = this.form.id ? "update_internal_dashboard" : "create_internal_dashboard";
    //   if (this.form.id) item.id = this.form.id;
    //   axios.post(this.api(path), { item }).then(() => {
    //     this.$vs.notify({ title: "Saved", text: "Dashboard saved", color: "success" });
    //     this.editing = false;
    //     this.loadList();
    //   }).catch(() => this.$vs.notify({ title: "Error", text: "Could not save", color: "danger" }));
    // },
    // remove(d) {
    //   axios.post(this.api("delete_internal_dashboard"), { item: { id: d.id } }).then(() => this.loadList());
    // },
    // cancel() { this.editing = false; }
  },
  mounted() {
    // this.loadList();
    // this.loadRefs();
    this.getInternalDashboardDataSource();

  }
};
</script>